var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"index-metric-ops\">\n<h4>Operations</h4>\n<table class=\"table table-condensed table-hover table-striped\">\n<thead>\n<tr>\n<th></th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>Flush</td>\n<td>{{indexMetricOpsCtrl.stats.total.flush.total | numeral: '0[,][0]'}}</td>\n</tr>\n<tr>\n<td>Refresh</td>\n<td>{{indexMetricOpsCtrl.stats.total.refresh.total | numeral: '0[,][0]'}}</td>\n</tr>\n<tr>\n<td>Merges</td>\n<td>{{indexMetricOpsCtrl.stats.total.merges.total | numeral: '0[,][0]'}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/index-metric-ops/index-metric-ops.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/index-metric-ops/index-metric-ops.template.html
// module id = 896
// module chunks = 0